import webResourceClient from '@common/api/webResourceClient';
import { type UserLevel } from '@common/types/api';
import { type GuidedTourConfig, type GuidedTourRef, type TourStep } from '@common/types/guidedTour';

export const fetchUnderMaintenanceText = async (location: string): Promise<string | undefined> => {
  try {
    const { data } = await webResourceClient.get<string>(location);
    return data;
  } catch {
    return undefined;
  }
};

export const fetchGuidedTourConfiguration = async (
  baseUrl: string,
  role: UserLevel,
): Promise<GuidedTourRef | undefined> => {
  try {
    const { data: specs } = await webResourceClient.get<GuidedTourConfig>(`${baseUrl}/specs.json`);
    return specs[role];
  } catch {
    return undefined;
  }
};

export const fetchGuidedTourContent = async (baseUrl: string, roleSpecs: GuidedTourRef) => {
  try {
    const resolvedSteps = await Promise.all(
      roleSpecs.steps.map((step) => webResourceClient.get<TourStep>(`${baseUrl}/${step}`)),
    );
    return {
      version: roleSpecs.version,
      steps: resolvedSteps.map(({ data: step }) => ({
        ...step,
        mediaUrl: step.mediaUrl ? `${baseUrl}/${step.mediaUrl}` : undefined,
      })),
    };
  } catch {
    return undefined;
  }
};

export const fetchNewFeatureConfiguration = async (featureId: string) => {
  const { data } = await webResourceClient.get<TourStep>(
    `${process.env.PUBLIC_PATH}assets/new-features/${featureId}.json`,
  );
  return data;
};
